import * as React from 'react'

export const ToggleButton = ({ onClick, isOpen, classNames }: {onClick: any, isOpen?: boolean, classNames?: string}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`toggle--button ${isOpen && 'open'} ${classNames && classNames}`}
        />
    )
}
